// AcademicUnitInfo.js
import { Box, Grid, Title, Text, Skeleton, List, ThemeIcon, Spoiler, Select, CopyButton, Tooltip, ActionIcon, Group, Flex, rem, SimpleGrid } from "@mantine/core";
import { IconCheck, IconCopy, IconSchool } from "@tabler/icons-react";
import { User } from "tabler-icons-react";

const AcademicUnitUserInfo = ({
  mainPosition,
  otherPositions,
  schoolDetail,
  careersDetails,
  sedesDetails,
  selectedSede, // Sede actualmente seleccionada
  onSedeChange, // Función para manejar el cambio de sede
  loadingState,
}) => {

  return (
    <>
      <Box
        style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr 1.5fr',
          gridTemplateRows: '1fr 1fr',
          gap: '1rem',
          gridTemplateAreas: `"box1 box2 box4""box3 box3 box4"`,}}
      >
        <Box style={{ gridArea: 'box1' }}>
          <Text tt={'uppercase'} fw={700} size={'xs'}>Nombre</Text>
          {loadingState ? ( <Skeleton height={30} mt={5} radius="md" /> ) : 
            mainPosition.nombre && mainPosition.apellido ? (
              <>
                <Text size={'lg'}>{mainPosition.nombre} {mainPosition.apellido}</Text>
                <Group wrap="nowrap" gap={3}>
                  <Text size={'sm'} c="dimmed">{mainPosition.mail}</Text>
                  <CopyButton value={mainPosition.mail} timeout={2000}>
                    {({ copied, copy }) => (
                      <Tooltip label={copied ? 'Copiado' : 'Copiar'} withArrow position="right">
                        <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                          {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                        </ActionIcon>
                      </Tooltip>
                    )}
                  </CopyButton>
                </Group>
              </>
            ) : ( <Text size={'sm'} c="dimmed">No disponible</Text> )
          }
        </Box>

        <Box style={{ gridArea: 'box2' }}>
          <Text tt={'uppercase'} fw={700} size={'xs'}>Facultad</Text>
          { loadingState ? ( <Skeleton height={30} mt={5} radius="md" /> ) : 
            schoolDetail.codFacultad && schoolDetail.descripcion ? (
              <Text size={'lg'}>
                <Text span inherit c={"#E72166"}>{schoolDetail.codFacultad}</Text> - {schoolDetail.descripcion}
              </Text>
            ) : ( <Text size={'sm'} c="dimmed">No disponible</Text>)
          }
        </Box>

        <Box style={{ gridArea: 'box3' }}>
          { loadingState ? ( <Skeleton height={30} mt={5} radius="md" /> ) : 
            otherPositions && otherPositions.length > 0 && (
              <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} verticalSpacing="xs" spacing="sm">
                {otherPositions.map((position, index) => (
                  <Box key={index}>
                    <Text tt={'uppercase'} fw={700} size={'xs'}>{position.descripcion}</Text>
                    <List size="sm">
                      {position?.usuarios?.map((user, index) => (
                        <List.Item key={index}>{user.nombre} {user.apellido}</List.Item>
                      ))}
                    </List>
                  </Box>
                ))}
              </SimpleGrid>  
            )
          }
        </Box>

        <Box style={{ gridArea: 'box4' }}>
          <Flex gap={15} direction={'row'}>
            <Box flex={2}>
              <Text tt={'uppercase'} fw={700} size={'xs'}>
                {careersDetails?.length > 1 ? 'Carreras' : 'Carrera'}
              </Text>
              {loadingState ? ( <Skeleton height={30} mt={6} radius="md" /> ) : 
                careersDetails?.length > 0 ? (
                  <List
                    spacing="xs"
                    mt={5}
                    size={careersDetails.length > 1 ? "sm" : 'md'}
                    center
                    icon={
                      <ThemeIcon color="#E72166" size={18} radius="xl">
                        <IconSchool size={14} />
                      </ThemeIcon>
                    }
                  >
                    <Spoiler maxHeight={rem(150)} showLabel="Ver más" hideLabel="Ocultar">
                      {careersDetails.map((career, index) => (
                        <List.Item key={index}>
                          <Text span inherit c={"#E72166"}>{career.codCarrera}</Text> - {career.descripcion}
                        </List.Item>
                      ))}
                    </Spoiler>
                  </List>
                ) : ( <Text size={'sm'} c="dimmed">No disponible</Text>)
              }
            </Box>

            {sedesDetails && sedesDetails?.length > 0 && (
              <Box flex={1}>
                <Text tt={'uppercase'} fw={700} size={'xs'}>Sedes</Text>
                <Select
                  placeholder="Seleccione una sede"
                  checkIconPosition="right"
                  allowDeselect={false}
                  data={sedesDetails}
                  value={selectedSede}
                  onChange={onSedeChange}
                />
              </Box>
            )}
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default AcademicUnitUserInfo;